import { render, staticRenderFns } from "./hazardChemPop.vue?vue&type=template&id=5522bb92"
import script from "./hazardChemPop.vue?vue&type=script&lang=js"
export * from "./hazardChemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5522bb92')) {
      api.createRecord('5522bb92', component.options)
    } else {
      api.reload('5522bb92', component.options)
    }
    module.hot.accept("./hazardChemPop.vue?vue&type=template&id=5522bb92", function () {
      api.rerender('5522bb92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/hazardChem/hazardChemPop.vue"
export default component.exports